import SectionActivities from './sectionActivities.js';
export default SectionActivities;
